// istanbul ignore file
// TODO: Remove as part of DMD-4865
import { MEDIUM_SOY, SOY, WHITE } from 'reservations/brand/helpers/v1/palette';

export const TARGET_IDENTIFIERS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  // We transform 'p' into 'body1' to follow mui's syntax but
  // for the underlying data this is actually 'p'.
  PARAGRAPH: 'body1',
  CARD: 'bentobox--card',
  PAGE: 'bentobox--page',
  PAGE_ERROR: 'bentobox--page--error',
  PRIMARY_BUTTON: 'bentobox--primary-button',
  PRIMARY_BUTTON_HOVER: 'bentobox--primary-button:hover',
  LINK: 'a',
  LINK_HOVER: 'a:hover'
};

export const TYPOGRAPHY_STYLE_ATTRIBUTES = [
  'color',
  'fontFamily',
  'fontWeight',
  'fontSize',
  'fontStyle',
  'letterSpacing',
  'lineHeight',
  'textTransform'
];

export const DEFAULT_BACKGROUND_VALUES = {
  primary: WHITE,
  secondary: 'rgba(0,0,0,0.5)'
};

export const NO_OPACITY_WHITE = 'rgba(255, 255, 255, 0)';

export const DEFAULT_BUTTON_COLORS = {
  color: WHITE,
  backgroundColor: SOY,
  hoverColor: WHITE,
  hoverBackgroundColor: MEDIUM_SOY
};

export const DEFAULT_LINK_COLORS = {
  color: MEDIUM_SOY,
  hoverColor: WHITE
};

export const BOX_SHADOW_NORMAL =
  'rgba(0, 0, 0, 0.08) 0px 3px 10px 0px, rgba(0, 0, 0, 0.01) 0px 1px 0px 0px, rgba(0, 0, 0, 0.01) 0px 0px 5px 0px';
